<template>
     <div class="w-full">
        <carousel :settings="settings" :breakpoints="breakpoints" class="mx-auto pt-3">
            <slide v-for="d in carouselData" :key="d.title" v-bind:name="d.title"
            class="px-4 flex flex-col align-start justify-start content-start">
                <div class="flex flex-col align-center justify-center content-center">
                    <div class="w-full flex align-center justify-center content-center">
                        <img class="w-52" v-bind:src="d.thumbnail" v-bind:alt="d.title" />
                    </div>
                    <div class="text-center py-5">
                        <h3 class="text-xl text-green-500 font-bold mb-2">{{ d.title }}</h3>
                        <p class="text-sm text-gray-800 px-10 block">{{ d.info }}</p>
                    </div>
                </div>
            </slide>
            <template #addons="">
            <Navigation />
            <Pagination />
            </template>
        </carousel>
    </div>
</template>


<script>
// If you are using PurgeCSS, make sure to whitelist the carousel CSS classes
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import { thankyouTranslate } from '@/translations/ThankYou.js'

import imageA from "@/assets/img/landing/img-pasos-iniciasesion-icono.svg"
import imageB from "@/assets/img/landing/img-pasos-descuentos-icono.svg"
import imageC from "@/assets/img/landing/img-pasos-membresia-icono.svg"

import { computed } from '@vue/reactivity';

export default {
    name: 'CarouselReservacion',
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation,
    },
    data: () => {
        return {
        props: ['thumbnail', 'title', 'info'],
        // carousel settings
        settings: {
            snapAlign: 'center',
            mouseDrag: false,
            touchDrag: true,
            wrapAround: true
        },
        // breakpoints are mobile first
        // any settings not specified will fallback to the carousel settings
        breakpoints: {
            // 700px and up
            700: {
                itemsToShow: 2,
                snapAlign: 'center',
            },
            // 1024 and up
            1024: {
                itemsToShow: 3,
                snapAlign: 'start',
            },
        },
    }
    },
    setup(){
        
        const language = computed( ()=> {
            return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
        })
        const carouselData =  [
            {
            thumbnail: imageA,
            title: thankyouTranslate[language.value].slides.reservationItems[0].title,
            info:  thankyouTranslate[language.value].slides.reservationItems[0].subtitle,
            },
            {
            thumbnail: imageB,
            title: thankyouTranslate[language.value].slides.reservationItems[1].title,
            info:  thankyouTranslate[language.value].slides.reservationItems[1].subtitle,
            },
            {
            thumbnail: imageC,
            title: thankyouTranslate[language.value].slides.reservationItems[2].title,
            info:  thankyouTranslate[language.value].slides.reservationItems[2].subtitle,
            }
        ]

        return {
            carouselData,
            language
        }

     }

}
</script>

<style scoped>
.carousel__slide{
    justify-content:flex-start;
}
.carousel__item {
  min-height: 200px;
  width: 100%;
  background-color: var(--vc-clr-primary);
  color:  var(--vc-clr-white);
  font-size: 20px;
  border-radius: 8px;
  display: flex;
  justify-content:flex-start;
  align-items: center;
}
.carousel__slide {
  padding: 10px;
  width:100%;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}

.carousel__prev,
.carousel__next {
    background-color: rgba(39, 113, 235, var(--tw-bg-opacity));
}

.carousel__pagination-button--active {
    background-color: #1d5d25!important;
}
.carousel__pagination-button {
    background-color: #ACACAC;
}
@media screen and (min-width: 1024px) {
    button.carousel__prev, button.carousel__next,ol.carousel__pagination {
        display: none!important;
    }
}
</style>